import React from 'react';

// Types
import { InsightType } from 'Shared/types/Capture.types';

// Components
import WpIcon from 'Wpds/components/icon/WpIcon';
import FilterListItem from './FilterListItem';

// Styles
import './InsightFilterList.scss';

type IntegrationsFilterListItemProps = {
  option: string;
  selectedInsights: Array<InsightType>;
  updateFilters: Function;
};

const InsightFilterListItem = ({ option, selectedInsights = [], updateFilters }: IntegrationsFilterListItemProps) => {
  const isChecked = selectedInsights.includes(option as InsightType);

  const getIcon = () => {
    if (option === InsightType.BLOCKED) return <WpIcon name="minus-octagon" />;
    if (option === InsightType.ACTIVE) return <WpIcon name="bolt" />;
    if (option === InsightType.NEW) return <WpIcon name="bell" />;

    return null;
  };

  const handleChange = (checked: boolean) => {
    if (updateFilters) {
      if (checked) updateFilters({ insight: [...selectedInsights, option] });
      else updateFilters({ insight: selectedInsights.filter(type => type !== option) });
    }
  };

  return (
    <FilterListItem id={option} label={option} isChecked={isChecked} onChange={handleChange}>
      <div className="InsightFilterList__item">
        <div className="InsightFilterList__item__icon">{getIcon()}</div>
        {option}
      </div>
    </FilterListItem>
  );
};

type Props = {
  surfaceData;
  selectedInsights: Array<InsightType>;
  updateFilters: Function;
};
const InsightFilterList = ({ surfaceData, selectedInsights = [], updateFilters }: Props) => {
  if (!surfaceData) return null;

  const insightFilterOptions = [InsightType.BLOCKED, InsightType.ACTIVE, InsightType.NEW];

  return (
    <div>
      {insightFilterOptions.map(option => (
        <InsightFilterListItem
          key={`filter-insight-${option}`}
          option={option}
          selectedInsights={selectedInsights}
          updateFilters={updateFilters}
        />
      ))}
    </div>
  );
};

export default InsightFilterList;
